import { IGetCostsQueryParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCosts/getCostsQuery.type';
import { getCostsFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCosts/getCostsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getCostsQueryOptions = (params: IGetCostsQueryParams) => {
  return queryOptions({
    queryKey: ['costs', params],
    queryFn: () => getCostsFunction(params),
  });
};
